"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
var _edit = _interopRequireDefault(require("./edit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  // name: "index"
  components: {
    edit: _edit.default
  },
  props: {
    selectModel: {
      type: Boolean,
      default: false
    },
    /** 选择模式下打开时回显：已关联的表单模板 id */
    initialSelectedFormId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        keywords: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      editDialogConfig: {
        visible: false,
        editData: {},
        isCreate: 0
      },
      dataList: {
        list: [],
        total: 0
      },
      selectedConfigData: {},
      /** formId 字符串 -> 引用该表单的配置分类名称列表（与商城默认设置同一棵配置分类树） */
      formIdToLinkedCategoryNames: {}
    };
  },
  watch: {
    initialSelectedFormId: function initialSelectedFormId() {
      if (!this.selectModel) return;
      this.listPram.page = 1;
      this.handlerGetList(this.listPram);
    }
  },
  mounted: function mounted() {
    if (!this.selectModel) {
      this.loadConfigCategoryFormLinks();
    }
    if (this.selectModel) {
      this.listPram.page = 1;
    }
    this.handlerGetList(this.listPram);
  },
  methods: {
    applyInitialTableCurrentRow: function applyInitialTableCurrentRow() {
      var _this = this;
      if (!this.selectModel || !this.$refs.formTemplateTable) return;
      var list = this.dataList.list || [];
      var raw = this.initialSelectedFormId;
      if (raw == null || raw === '') {
        this.selectedConfigData = {};
        this.$refs.formTemplateTable.setCurrentRow();
        return;
      }
      var target = Number(raw);
      if (Number.isNaN(target) || target <= 0) {
        this.selectedConfigData = {};
        this.$refs.formTemplateTable.setCurrentRow();
        return;
      }
      var row = list.find(function (r) {
        return Number(r.id) === target;
      });
      if (row) {
        this.$refs.formTemplateTable.setCurrentRow(row);
        this.selectedConfigData = row;
        return;
      }
      this.$refs.formTemplateTable.setCurrentRow();
      systemFormConfigApi.getFormConfigInfo({
        id: target
      }).then(function (data) {
        if (!_this.selectModel) return;
        if (!data || data.id == null) {
          _this.selectedConfigData = {};
          return;
        }
        // 异步返回晚于用户已在表格中点选其它行时，不得覆盖当前选择
        var curId = _this.selectedConfigData && _this.selectedConfigData.id != null ? Number(_this.selectedConfigData.id) : NaN;
        if (!Number.isNaN(curId) && curId !== target) {
          return;
        }
        _this.selectedConfigData = {
          id: data.id,
          name: data.name,
          info: data.info,
          updateTime: data.updateTime
        };
      }).catch(function () {
        _this.selectedConfigData = {};
      });
    },
    /** 与 mallDefaultSetting 一致：配置分类树子节点 extra 为表单模板 id */loadConfigCategoryFormLinks: function loadConfigCategoryFormLinks() {
      var _this2 = this;
      var type = this.$constants.categoryType[5].value;
      categoryApi.treeCategroy({
        type: type,
        status: 1
      }).then(function (tree) {
        var map = {};
        var walk = function walk(nodes) {
          if (!nodes || !nodes.length) return;
          nodes.forEach(function (n) {
            var extra = n.extra;
            if (extra !== undefined && extra !== null && String(extra).trim() !== '') {
              var key = String(extra).trim();
              if (!map[key]) map[key] = [];
              var label = n.name || "\u5206\u7C7B#".concat(n.id);
              if (!map[key].includes(label)) {
                map[key].push(label);
              }
            }
            if (n.child && n.child.length) {
              walk(n.child);
            }
          });
        };
        walk(tree || []);
        _this2.formIdToLinkedCategoryNames = map;
      }).catch(function () {
        _this2.formIdToLinkedCategoryNames = {};
      });
    },
    isFormLinkedByConfigCategory: function isFormLinkedByConfigCategory(row) {
      if (!row || row.id == null) return false;
      var names = this.formIdToLinkedCategoryNames[String(row.id)];
      return !!(names && names.length);
    },
    linkedCategoryLabel: function linkedCategoryLabel(row) {
      var names = this.formIdToLinkedCategoryNames[String(row.id)];
      if (!names || !names.length) return '';
      var text = names.join('、');
      return "\u5DF2\u5173\u8054\u300C".concat(text, "\u300D");
    },
    handlerSearch: function handlerSearch() {
      this.listPram.page = 1;
      this.handlerGetList(this.listPram);
    },
    handlerGetList: function handlerGetList(pram) {
      var _this3 = this;
      systemFormConfigApi.getFormConfigList(pram).then(function (data) {
        _this3.dataList = data;
        _this3.$nextTick(function () {
          return _this3.applyInitialTableCurrentRow();
        });
      });
    },
    handlerEditData: function handlerEditData(rowData, isCreate) {
      if (isCreate === 0) {
        this.editDialogConfig.editData = {};
      } else {
        this.editDialogConfig.editData = rowData;
      }
      this.editDialogConfig.isCreate = isCreate;
      this.editDialogConfig.visible = true;
    },
    handlerHide: function handlerHide() {
      this.editDialogConfig.editData = {};
      this.editDialogConfig.isCreate = 0;
      this.editDialogConfig.visible = false;
      this.loadConfigCategoryFormLinks();
      this.handlerGetList(this.listPram);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetList(this.listPram);
    },
    handleCurrentRowChange: function handleCurrentRowChange(rowData) {
      this.selectedConfigData = rowData || {};
      // 选择模式：点选行即同步到外层（避免只点「保存关联」未点「确定选择」仍提交旧 extra）
      if (this.selectModel && rowData && rowData.id != null) {
        this.$emit('form-current-row', rowData);
      }
    },
    handlerConfimSelect: function handlerConfimSelect() {
      this.$emit('selectedRowData', this.selectedConfigData);
    }
  }
};